const mimes: Record<string, string> = {
    ".png": "image/png",
    ".jpg": "image/jpeg",
    ".jpeg": "image/jpeg",
    ".gif": "image/gif",
    ".bmp": "image/bmp",
    ".webp": "image/webp",
    ".doc": "application/msword",
    ".docx":
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".xls": "application/vnd.ms-excel",
    ".xlsx":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".pdf": "application/pdf",
};

export function filenameToMime(filename: string): string {
    const extMatch = filename.match(/\.([^.]+)$/);
    if (extMatch && extMatch[1]) {
        const mime = mimes[`.${extMatch[1]}`];
        if (mime) {
            return mime;
        }
    }
    return "unknown";
}
